import { isDefined } from "@wisr/common";
import React from "react";
import { Helmet } from "react-helmet";

interface Props {
  title?: string;
  description?: string;
}
export const HelmetSeoComponent: React.FunctionComponent<Props> = (props) => {
  const siteName = " | Wisr";
  return (
    <Helmet>
      {isDefined(props.title) && [
        <title key="title">{props.title + siteName}</title>,
        <meta key="meta:title" name="title" content={props.title + siteName} />,
        <meta
          key="og:title"
          property="og:title"
          content={props.title + siteName}
        />,
        <meta
          key="twitter:title"
          name="twitter:title"
          content={props.title + siteName}
        />,
      ]}
      {isDefined(props.description) && [
        <meta
          key="meta:description"
          name="description"
          content={props.description}
        />,
        <meta
          key="og:description"
          property="og:description"
          content={props.description}
        />,
        <meta
          key="twitter:description"
          name="twitter:description"
          content={props.description}
        />,
      ]}
      {props.children}
    </Helmet>
  );
};
